module.exports = __webpack_public_path__ + "img/play-pink.15785588.svg";